<template>
    <div :class="{ 'position-top-left': positionTopLeft }">
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 370 100"
            aria-labelledby="pendo-logo-title">
            <title id="pendo-logo-title">{{ $t('Pendo logo') }}</title>
            <polygon
                fill="var(--static-palette-pink-110)"
                points="39.77 23.25 2.86 60.17 39.77 60.17 39.77 97.08 76.69 60.17 76.69 23.25 39.77 23.25" />
            <path
                :fill="fill"
                d="M119.38,31.39a24.25,24.25,0,0,0-16.6,6.51V31.33H94.92V97.08h7.86V73.79a24.45,24.45,0,1,0,16.6-42.4ZM136,55.85a16.6,16.6,0,1,1-16.59-16.6A16.61,16.61,0,0,1,136,55.85Z" />
            <path
                :fill="fill"
                d="M174.33,31.33a24.46,24.46,0,0,0,0,48.92c7.55,0,14.49-2.83,19-7.76l2.36-2.56.3-.33-.33-.31-5.12-4.71-.33-.31-.31.33-2.35,2.57c-3,3.26-8,5.21-13.24,5.21a16.66,16.66,0,0,1-16.12-12.66h39.95V55.79C198.16,42.08,187.69,31.33,174.33,31.33ZM158.21,51.86A16.66,16.66,0,0,1,174.33,39.2a15.87,15.87,0,0,1,15.53,12.66Z" />
            <path
                :fill="fill"
                d="M227.89,31.33a22.34,22.34,0,0,0-15.17,6v-6h-7.86v49.3h7.86V55.47c0-9,6.81-16.27,15.17-16.27s15.17,7.3,15.17,16.27V80.63h7.86V55.47C250.92,42.16,240.59,31.33,227.89,31.33Z" />
            <path
                :fill="fill"
                d="M299.08,14.88h-.45V38.17a24.46,24.46,0,1,0,0,35.89v6.57h7.86V14.88h-7.41Zm-.45,41.24A16.6,16.6,0,1,1,282,39.52,16.61,16.61,0,0,1,298.63,56.12Z" />
            <path
                :fill="fill"
                d="M337.76,31.66a24.46,24.46,0,1,0,24.45,24.46A24.48,24.48,0,0,0,337.76,31.66Zm16.59,24.46a16.6,16.6,0,1,1-16.59-16.6A16.61,16.61,0,0,1,354.35,56.12Z" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'PendoLogo',
    props: {
        type: {
            type: String,
            default: 'day',
            validator: (type) => ['day', 'night'].includes(type),
        },
        positionTopLeft: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        fill () {
            if (this.type === 'night') {
                return 'var(--static-palette-gray-0)';
            }

            return 'var(--static-brand-neutrals-brand-off-black)';
        },
    },
};
</script>

<style lang="less" scoped>
svg {
    height: 33px;
}

.position-top-left {
    position: absolute;
    left: 33px;
    top: 33px;

    @media only screen and (max-width: 767px) {
        align-self: center;
        position: relative;
        top: auto;
        left: auto;
    }
}
</style>
